import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { DIRECT_HOLDINGS } from 'ModelPortfolioApp/ts/shared/constants';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class HoldingsCategoriesService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        this.cachedData = {};
    }
    queryHoldingsCategories(securityId, categoryType, holdingsLayer) {
        // Query a Holdings Categories object from a GET request to `/securities/holdings_categories/{{ securityId }}`.
        // We can move this into security service if becomes more widely used.
        const url = this.urlsService.getUrl(this.urlsService.SECURITIES.HOLDINGS_CATEGORIES, { securityId }, { category: categoryType, holdings_layer: holdingsLayer });
        return this.ajaxService.getDataObserveBody(url);
    }
    /**
     * Retrieve categorized holdings for a security ID & category type. The result will be cached.
     *
     * @param securityId: Security ID.
     * @param categoryType: Target category type.
     */
    getHoldingsCategories(securityId, categoryType, holdingsLayer = DIRECT_HOLDINGS) {
        if (categoryType in this.cachedData && holdingsLayer in this.cachedData[categoryType])
            return of(this.cachedData[categoryType][holdingsLayer]);
        return this.queryHoldingsCategories(securityId, categoryType, holdingsLayer).pipe(tap((categories) => {
            if (typeof this.cachedData[categoryType] !== 'undefined') {
                this.cachedData[categoryType][holdingsLayer] = categories;
            }
            else {
                this.cachedData[categoryType] = { holdingsLayer: categories };
            }
        }));
    }
}
HoldingsCategoriesService.ɵfac = function HoldingsCategoriesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsCategoriesService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
HoldingsCategoriesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HoldingsCategoriesService, factory: HoldingsCategoriesService.ɵfac, providedIn: 'root' });
